const phrases = [
  // Wealth and Generosity
  {
    id: "wealth_1",
    category: "Wealth & Generosity",
    arabic: "مال البخيل ياكله العيار",
    transliteration: "Mal al-bakheel yakluh al-ayar",
    translation: "The miser's money will be eaten by the thief",
    meaning:
      "Wealth that is hoarded rather than shared or invested wisely will eventually be lost or stolen",
    words: [
      { arabic: "مال", transliteration: "mal", translation: "money/wealth" },
      { arabic: "البخيل", transliteration: "al-bakheel", translation: "the miser" },
      { arabic: "ياكله", transliteration: "yakluh", translation: "will eat it" },
      { arabic: "العيار", transliteration: "al-ayar", translation: "the thief" },
    ],
  },
  {
    id: "wealth_2",
    category: "Wealth & Generosity",
    arabic: "حط فلوسك بالشمس وإقعد بالظلال",
    transliteration: "Hat floosak bil shams wa ug'ud bil thalal",
    translation: "Put your money in the sun and sit in the shade",
    meaning: "Invest your money wisely so you can relax and enjoy life without worry",
    words: [
      { arabic: "حط", transliteration: "hat", translation: "put" },
      { arabic: "فلوسك", transliteration: "floosak", translation: "your money" },
      { arabic: "بالشمس", transliteration: "bil shams", translation: "in the sun" },
      { arabic: "وإقعد", transliteration: "wa ug'ud", translation: "and sit" },
      { arabic: "بالظلال", transliteration: "bil thalal", translation: "in the shade" },
    ],
  },
  {
    id: "wealth_3",
    category: "Wealth & Generosity",
    arabic: "إصرف ما في الجيب يأتيك ما في الغيب",
    transliteration: "Israf ma fil jeeb yateek ma fil ghaib",
    translation: "Spend what's in your pocket, and what's hidden will come to you",
    meaning: "Be generous with what you have, and more will come your way",
    words: [
      { arabic: "إصرف", transliteration: "israf", translation: "spend" },
      { arabic: "ما", transliteration: "ma", translation: "what" },
      { arabic: "في", transliteration: "fil", translation: "in" },
      { arabic: "الجيب", transliteration: "al-jeeb", translation: "the pocket" },
      { arabic: "يأتيك", transliteration: "yateek", translation: "will come to you" },
      { arabic: "الغيب", transliteration: "al-ghaib", translation: "the hidden/unseen" },
    ],
  },

  // Human Nature & Character
  {
    id: "nature_1",
    category: "Human Nature & Character",
    arabic: "من طمع طبع",
    transliteration: "Min tama' taba'",
    translation: "He who is greedy becomes imprinted (by greed)",
    meaning: "Greed becomes a permanent part of one's character",
    words: [
      { arabic: "من", transliteration: "min", translation: "who" },
      { arabic: "طمع", transliteration: "tama'", translation: "is greedy" },
      { arabic: "طبع", transliteration: "taba'", translation: "becomes imprinted" },
    ],
  },
  {
    id: "nature_2",
    category: "Human Nature & Character",
    arabic: "من قال (ها) سمع",
    transliteration: "Min gal (ha) sama'",
    translation: "He who says 'ha' will hear",
    meaning: "If you speak up or ask questions, you'll receive answers",
    words: [
      { arabic: "من", transliteration: "min", translation: "who" },
      { arabic: "قال", transliteration: "gal", translation: "says" },
      { arabic: "ها", transliteration: "ha", translation: "ha" },
      { arabic: "سمع", transliteration: "sama'", translation: "will hear" },
    ],
  },
  {
    id: "nature_3",
    category: "Human Nature & Character",
    arabic: "نوم الظالم عباده",
    transliteration: "Nom al-thalim ibada",
    translation: "The sleep of the oppressor is worship",
    meaning: "When an unjust person sleeps, they're not causing harm, which is a blessing",
    words: [
      { arabic: "نوم", transliteration: "nom", translation: "sleep" },
      { arabic: "الظالم", transliteration: "al-thalim", translation: "the oppressor" },
      { arabic: "عباده", transliteration: "ibada", translation: "worship" },
    ],
  },
  {
    id: "nature_4",
    category: "Human Nature & Character",
    arabic: "إذا شبع الحمار نهق",
    transliteration: "Itha shiba' al-himar nahaq",
    translation: "When the donkey is full, it brays",
    meaning:
      "People show their true (often unpleasant) nature when they are comfortable or satisfied",
    words: [
      { arabic: "إذا", transliteration: "itha", translation: "when" },
      { arabic: "شبع", transliteration: "shiba'", translation: "is full" },
      { arabic: "الحمار", transliteration: "al-himar", translation: "the donkey" },
      { arabic: "نهق", transliteration: "nahaq", translation: "brays" },
    ],
  },
  {
    id: "nature_5",
    category: "Human Nature & Character",
    arabic: "بغيناه عون صار فرعون",
    transliteration: "Baghainah 'awn sar fir'awn",
    translation: "We wanted him as a helper, but he became a pharaoh",
    meaning: "Someone given a little power who becomes tyrannical",
    words: [
      { arabic: "بغيناه", transliteration: "baghainah", translation: "we wanted him" },
      { arabic: "عون", transliteration: "'awn", translation: "as help" },
      { arabic: "صار", transliteration: "sar", translation: "became" },
      { arabic: "فرعون", transliteration: "fir'awn", translation: "pharaoh" },
    ],
  },
  {
    id: "nature_6",
    category: "Human Nature & Character",
    arabic: "أبو طبيع ما يوز من طبعه",
    transliteration: "Abu tabi' ma yooz min tab'ah",
    translation: "A person of habit doesn't deviate from their nature",
    meaning: "People rarely change their fundamental character",
    words: [
      { arabic: "أبو", transliteration: "abu", translation: "father of" },
      { arabic: "طبيع", transliteration: "tabi'", translation: "habit" },
      { arabic: "ما", transliteration: "ma", translation: "not" },
      { arabic: "يوز", transliteration: "yooz", translation: "deviates" },
      { arabic: "من", transliteration: "min", translation: "from" },
      { arabic: "طبعه", transliteration: "tab'ah", translation: "his nature" },
    ],
  },

  // Wisdom & Experience
  {
    id: "wisdom_1",
    category: "Wisdom & Experience",
    arabic: "إسأل مجرب ولا تسأل طبيب",
    transliteration: "Is'al mujarib wala tis'al tabeeb",
    translation: "Ask someone with experience rather than a doctor",
    meaning:
      "Experience is more valuable than theoretical knowledge. This proverb emphasizes the importance of practical wisdom over academic learning",
    words: [
      { arabic: "إسأل", transliteration: "is'al", translation: "ask" },
      { arabic: "مجرب", transliteration: "mujarib", translation: "experienced person" },
      { arabic: "ولا", transliteration: "wala", translation: "and not" },
      { arabic: "تسأل", transliteration: "tis'al", translation: "you ask" },
      { arabic: "طبيب", transliteration: "tabeeb", translation: "doctor" },
    ],
  },
  {
    id: "wisdom_2",
    category: "Wisdom & Experience",
    arabic: "اللي ما يعرف الصقر يشويه",
    transliteration: "Illi ma ya'rif al-saqr yishweeh",
    translation: "He who doesn't know the falcon will roast it",
    meaning:
      "Those who don't recognize value will waste it. This speaks to the importance of knowledge and appreciation",
    words: [
      { arabic: "اللي", transliteration: "illi", translation: "who" },
      { arabic: "ما", transliteration: "ma", translation: "not" },
      { arabic: "يعرف", transliteration: "ya'rif", translation: "knows" },
      { arabic: "الصقر", transliteration: "al-saqr", translation: "the falcon" },
      { arabic: "يشويه", transliteration: "yishweeh", translation: "will roast it" },
    ],
  },
  {
    id: "wisdom_3",
    category: "Wisdom & Experience",
    arabic: "مايعرف رأسه من كرياسه",
    transliteration: "Ma ya'rif rasah min kiryasah",
    translation: "He doesn't know his head from his notebook",
    meaning: "Used to describe someone who is extremely confused or ignorant",
    words: [
      { arabic: "مايعرف", transliteration: "ma ya'rif", translation: "doesn't know" },
      { arabic: "رأسه", transliteration: "rasah", translation: "his head" },
      { arabic: "من", transliteration: "min", translation: "from" },
      { arabic: "كرياسه", transliteration: "kiryasah", translation: "his notebook" },
    ],
  },
  {
    id: "wisdom_4",
    category: "Wisdom & Experience",
    arabic: "الطول طول نخله والعقل عقل صخله",
    transliteration: "Al-tool tool nakhla wal-aqil aqil sakhla",
    translation: "The height of a palm tree but the mind of a lamb",
    meaning: "Someone who is physically grown but mentally immature",
    words: [
      { arabic: "الطول", transliteration: "al-tool", translation: "the height" },
      { arabic: "طول", transliteration: "tool", translation: "height" },
      { arabic: "نخله", transliteration: "nakhla", translation: "palm tree" },
      { arabic: "والعقل", transliteration: "wal-aqil", translation: "and the mind" },
      { arabic: "عقل", transliteration: "aqil", translation: "mind" },
      { arabic: "صخله", transliteration: "sakhla", translation: "lamb" },
    ],
  },

  // Fate & Opportunity
  {
    id: "fate_1",
    category: "Fate & Opportunity",
    arabic: "طارت الطيور بأرزاقها",
    transliteration: "Tarat al-tuyoor bi arzaqiha",
    translation: "The birds flew with their provisions",
    meaning: "Everyone has their own destiny and sustenance determined by fate",
    words: [
      { arabic: "طارت", transliteration: "tarat", translation: "flew" },
      { arabic: "الطيور", transliteration: "al-tuyoor", translation: "the birds" },
      { arabic: "بأرزاقها", transliteration: "bi arzaqiha", translation: "with their provisions" },
    ],
  },
  {
    id: "fate_2",
    category: "Fate & Opportunity",
    arabic: "تجيك التهايم وإنت نايم",
    transliteration: "Tejeek al-tahayim want nayim",
    translation: "Good fortune comes to you while you're sleeping",
    meaning: "Sometimes luck and opportunity come without effort",
    words: [
      { arabic: "تجيك", transliteration: "tejeek", translation: "comes to you" },
      { arabic: "التهايم", transliteration: "al-tahayim", translation: "good fortune" },
      { arabic: "وإنت", transliteration: "want", translation: "and you" },
      { arabic: "نايم", transliteration: "nayim", translation: "sleeping" },
    ],
  },
  {
    id: "fate_3",
    category: "Fate & Opportunity",
    arabic: "زرع الميانين يطلعه رب العالمين",
    transliteration: "Zara' al-mayaneen yitla'ah rab al-alameen",
    translation: "What the crazy ones plant, God makes grow",
    meaning:
      "Even foolish efforts can succeed with divine blessing; sometimes irrational actions yield surprising results",
    words: [
      { arabic: "زرع", transliteration: "zara'", translation: "planted" },
      { arabic: "الميانين", transliteration: "al-mayaneen", translation: "the crazy ones" },
      { arabic: "يطلعه", transliteration: "yitla'ah", translation: "makes it grow" },
      { arabic: "رب", transliteration: "rab", translation: "lord" },
      { arabic: "العالمين", transliteration: "al-alameen", translation: "of the worlds" },
    ],
  },

  // Social Relationships
  {
    id: "social_1",
    category: "Social Relationships",
    arabic: "الخال خلي والعم ولي",
    transliteration: "Al-khal khali wal-am wali",
    translation: "The maternal uncle is a friend, and the paternal uncle is a guardian",
    meaning: "Different family members play different roles in one's life",
    words: [
      { arabic: "الخال", transliteration: "al-khal", translation: "maternal uncle" },
      { arabic: "خلي", transliteration: "khali", translation: "friend" },
      { arabic: "والعم", transliteration: "wal-am", translation: "and paternal uncle" },
      { arabic: "ولي", transliteration: "wali", translation: "guardian" },
    ],
  },
  {
    id: "social_2",
    category: "Social Relationships",
    arabic: "ريلچ على ما عودتيه وولدچ على ماربيتيه",
    transliteration: "Raylich ala ma awadteeh wa waladich ala ma rabayteeh",
    translation: "Your husband is as you've accustomed him, and your son is as you've raised him",
    meaning: "People's behaviour reflects how they've been treated or raised",
    words: [
      { arabic: "ريلچ", transliteration: "raylich", translation: "your husband" },
      { arabic: "على", transliteration: "ala", translation: "is as" },
      { arabic: "ما", transliteration: "ma", translation: "what" },
      { arabic: "عودتيه", transliteration: "awadteeh", translation: "you accustomed him" },
      { arabic: "وولدچ", transliteration: "wa waladich", translation: "and your son" },
      { arabic: "ماربيتيه", transliteration: "ma rabayteeh", translation: "what you raised him" },
    ],
  },
  {
    id: "social_3",
    category: "Social Relationships",
    arabic: "كوم حجار ولا هالجار",
    transliteration: "Kom hijar wala hal jar",
    translation: "Better a pile of stones than this neighbour",
    meaning: "A bad neighbour is worse than having no neighbour at all",
    words: [
      { arabic: "كوم", transliteration: "kom", translation: "pile" },
      { arabic: "حجار", transliteration: "hijar", translation: "stones" },
      { arabic: "ولا", transliteration: "wala", translation: "than" },
      { arabic: "هالجار", transliteration: "hal jar", translation: "this neighbour" },
    ],
  },
  {
    id: "social_4",
    category: "Social Relationships",
    arabic: "إذا تباعدت المخده تباعدت الموده",
    transliteration: "Itha taba'adat al-mikhaddah taba'adat al-mawaddah",
    translation: "When the pillow distances, affection distances",
    meaning: "Physical distance can lead to emotional distance in relationships",
    words: [
      { arabic: "إذا", transliteration: "itha", translation: "when" },
      { arabic: "تباعدت", transliteration: "taba'adat", translation: "distanced" },
      { arabic: "المخده", transliteration: "al-mikhaddah", translation: "the pillow" },
      { arabic: "تباعدت", transliteration: "taba'adat", translation: "distanced" },
      { arabic: "الموده", transliteration: "al-mawaddah", translation: "affection" },
    ],
  },
  {
    id: "social_5",
    category: "Social Relationships",
    arabic: "الناس للناس والكل بالله",
    transliteration: "Al-nas lil-nas wal-kul billah",
    translation: "People are for people, and all depend on God",
    meaning: "We should help each other, while recognizing that ultimately we all depend on God",
    words: [
      { arabic: "الناس", transliteration: "al-nas", translation: "people" },
      { arabic: "للناس", transliteration: "lil-nas", translation: "for people" },
      { arabic: "والكل", transliteration: "wal-kul", translation: "and all" },
      { arabic: "بالله", transliteration: "billah", translation: "depend on God" },
    ],
  },
  {
    id: "social_6",
    category: "Social Relationships",
    arabic: "الحشره مع الناس عيد",
    transliteration: "Al-hashra ma' al-nas eid",
    translation: "Being with people is like a festival",
    meaning: "There is joy in community and social gatherings",
    words: [
      { arabic: "الحشره", transliteration: "al-hashra", translation: "being together" },
      { arabic: "مع", transliteration: "ma'", translation: "with" },
      { arabic: "الناس", transliteration: "al-nas", translation: "people" },
      { arabic: "عيد", transliteration: "eid", translation: "festival" },
    ],
  },
  {
    id: "social_7",
    category: "Social Relationships",
    arabic: "إيد وحده ماتصفق",
    transliteration: "Eed wahda ma tisfaq",
    translation: "One hand cannot clap",
    meaning: "Cooperation is necessary for success; one cannot accomplish everything alone",
    words: [
      { arabic: "إيد", transliteration: "eed", translation: "hand" },
      { arabic: "وحده", transliteration: "wahda", translation: "alone" },
      { arabic: "ما", transliteration: "ma", translation: "not" },
      { arabic: "تصفق", transliteration: "tisfaq", translation: "claps" },
    ],
  },

  // Caution & Wisdom
  {
    id: "caution_1",
    category: "Caution & Wisdom",
    arabic: "البحر ماله أمان",
    transliteration: "Al-bahr malah aman",
    translation: "The sea has no safety",
    meaning: "Be cautious of situations that seem calm but can quickly become dangerous",
    words: [
      { arabic: "البحر", transliteration: "al-bahr", translation: "the sea" },
      { arabic: "ماله", transliteration: "malah", translation: "has no" },
      { arabic: "أمان", transliteration: "aman", translation: "safety" },
    ],
  },
  {
    id: "caution_2",
    category: "Caution & Wisdom",
    arabic: "لا تأمن على فار شحمه",
    transliteration: "La ta'min ala far shahmah",
    translation: "Don't trust a mouse with fat",
    meaning: "Don't entrust valuable things to someone who will be tempted to take them",
    words: [
      { arabic: "لا", transliteration: "la", translation: "don't" },
      { arabic: "تأمن", transliteration: "ta'min", translation: "trust" },
      { arabic: "على", transliteration: "ala", translation: "on" },
      { arabic: "فار", transliteration: "far", translation: "mouse" },
      { arabic: "شحمه", transliteration: "shahmah", translation: "its fat" },
    ],
  },
  {
    id: "caution_3",
    category: "Caution & Wisdom",
    arabic: "لا تدخل عصك بشى مايخصك",
    transliteration: "La tidakhil 'asak bi shay ma yikhissak",
    translation: "Don't put your stick in something that doesn't concern you",
    meaning: "Don't interfere in matters that don't involve you",
    words: [
      { arabic: "لا", transliteration: "la", translation: "don't" },
      { arabic: "تدخل", transliteration: "tidakhil", translation: "put" },
      { arabic: "عصك", transliteration: "'asak", translation: "your stick" },
      { arabic: "بشى", transliteration: "bi shay", translation: "in something" },
      { arabic: "مايخصك", transliteration: "ma yikhissak", translation: "doesn't concern you" },
    ],
  },

  // Judgment & Character
  {
    id: "judgment_1",
    category: "Judgment & Character",
    arabic: "اللي ما يعرفك مايثمنك",
    transliteration: "Illi ma ya'rifak ma yithaminak",
    translation: "He who doesn't know you won't value you",
    meaning: "People can't appreciate your worth if they don't know you well",
    words: [
      { arabic: "اللي", transliteration: "illi", translation: "who" },
      { arabic: "ما", transliteration: "ma", translation: "not" },
      { arabic: "يعرفك", transliteration: "ya'rifak", translation: "knows you" },
      { arabic: "مايثمنك", transliteration: "ma yithaminak", translation: "won't value you" },
    ],
  },
  {
    id: "judgment_2",
    category: "Judgment & Character",
    arabic: "لو فيه خير ما عافه الطير",
    transliteration: "Law feeh khair ma 'afah al-tair",
    translation: "If there was good in it, birds wouldn't have abandoned it",
    meaning:
      "If something has been rejected by those who know it well, it probably has little value",
    words: [
      { arabic: "لو", transliteration: "law", translation: "if" },
      { arabic: "فيه", transliteration: "feeh", translation: "there was" },
      { arabic: "خير", transliteration: "khair", translation: "good" },
      { arabic: "ما", transliteration: "ma", translation: "not" },
      { arabic: "عافه", transliteration: "'afah", translation: "abandoned it" },
      { arabic: "الطير", transliteration: "al-tair", translation: "the bird" },
    ],
  },

  // Consequences & Limits
  {
    id: "consequences_1",
    category: "Consequences & Limits",
    arabic: "مد رجولك على قد لحافك",
    transliteration: "Mid rijoolak 'ala gad lihafak",
    translation: "Stretch your legs according to your blanket's length",
    meaning: "Live within your means; don't overextend yourself",
    words: [
      { arabic: "مد", transliteration: "mid", translation: "stretch" },
      { arabic: "رجولك", transliteration: "rijoolak", translation: "your legs" },
      { arabic: "على", transliteration: "ala", translation: "according to" },
      { arabic: "قد", transliteration: "gad", translation: "the size of" },
      { arabic: "لحافك", transliteration: "lihafak", translation: "your blanket" },
    ],
  },
  {
    id: "consequences_2",
    category: "Consequences & Limits",
    arabic: "لا تسرف لو من البحر تغرف",
    transliteration: "La tisrif law min al-bahr tighraf",
    translation: "Don't waste even if you're scooping from the sea",
    meaning: "Be economical and avoid waste, even when resources seem abundant",
    words: [
      { arabic: "لا", transliteration: "la", translation: "don't" },
      { arabic: "تسرف", transliteration: "tisrif", translation: "waste" },
      { arabic: "لو", transliteration: "law", translation: "even if" },
      { arabic: "من", transliteration: "min", translation: "from" },
      { arabic: "البحر", transliteration: "al-bahr", translation: "the sea" },
      { arabic: "تغرف", transliteration: "tighraf", translation: "you scoop" },
    ],
  },
  {
    id: "consequences_3",
    category: "Consequences & Limits",
    arabic: "كثر الدق يفك اللحام",
    transliteration: "Kathir al-dag yifik al-liham",
    translation: "Too much hammering breaks the weld",
    meaning: "Excessive pressure or repetition can ruin what was once strong",
    words: [
      { arabic: "كثر", transliteration: "kathir", translation: "too much" },
      { arabic: "الدق", transliteration: "al-dag", translation: "hammering" },
      { arabic: "يفك", transliteration: "yifik", translation: "breaks" },
      { arabic: "اللحام", transliteration: "al-liham", translation: "the weld" },
    ],
  },
  {
    id: "consequences_4",
    category: "Consequences & Limits",
    arabic: "إذا طاح الجمل كثرت سكاكينه",
    transliteration: "Itha tah al-jamal kathrat sakakeenah",
    translation: "When the camel falls, knives multiply",
    meaning: "When someone powerful falls, many will rush to take advantage",
    words: [
      { arabic: "إذا", transliteration: "itha", translation: "when" },
      { arabic: "طاح", transliteration: "tah", translation: "falls" },
      { arabic: "الجمل", transliteration: "al-jamal", translation: "the camel" },
      { arabic: "كثرت", transliteration: "kathrat", translation: "multiplied" },
      { arabic: "سكاكينه", transliteration: "sakakeenah", translation: "its knives" },
    ],
  },
  {
    id: "consequences_5",
    category: "Consequences & Limits",
    arabic: "جا يكحلها عماها",
    transliteration: "Ja yikahilha 'amaha",
    translation: "He came to apply kohl to her eye but blinded her",
    meaning: "Attempting to improve something but making it worse instead",
    words: [
      { arabic: "جا", transliteration: "ja", translation: "came" },
      { arabic: "يكحلها", transliteration: "yikahilha", translation: "to apply kohl to her" },
      { arabic: "عماها", transliteration: "'amaha", translation: "blinded her" },
    ],
  },

  // Relationships & Life Lessons
  {
    id: "relationships_1",
    category: "Relationships & Life Lessons",
    arabic: "لا صار حبيبك عسل لا تاكله كله",
    transliteration: "La sar habeebak 'asal la taklah killah",
    translation: "If your beloved becomes honey, don't eat it all",
    meaning: "Don't take advantage of someone's love or generosity",
    words: [
      { arabic: "لا", transliteration: "la", translation: "if" },
      { arabic: "صار", transliteration: "sar", translation: "became" },
      { arabic: "حبيبك", transliteration: "habeebak", translation: "your beloved" },
      { arabic: "عسل", transliteration: "'asal", translation: "honey" },
      { arabic: "لا", transliteration: "la", translation: "don't" },
      { arabic: "تاكله", transliteration: "taklah", translation: "eat it" },
      { arabic: "كله", transliteration: "killah", translation: "all of it" },
    ],
  },
  {
    id: "relationships_2",
    category: "Relationships & Life Lessons",
    arabic: "لا بغيت صاحبك دوم حاسبه كل يوم",
    transliteration: "La baghayt sahibak doom hasibah kil yom",
    translation: "If you want your friend to remain, settle accounts with him daily",
    meaning: "Clear communication and settling matters promptly preserves relationships",
    words: [
      { arabic: "لا", transliteration: "la", translation: "if" },
      { arabic: "بغيت", transliteration: "baghayt", translation: "you want" },
      { arabic: "صاحبك", transliteration: "sahibak", translation: "your friend" },
      { arabic: "دوم", transliteration: "doom", translation: "always" },
      { arabic: "حاسبه", transliteration: "hasibah", translation: "settle accounts" },
      { arabic: "كل", transliteration: "kil", translation: "every" },
      { arabic: "يوم", transliteration: "yom", translation: "day" },
    ],
  },
  {
    id: "relationships_3",
    category: "Relationships & Life Lessons",
    arabic: "الوجه بالوجه أبيض",
    transliteration: "Al-wajh bil-wajh abyad",
    translation: "Face to face is white (pure)",
    meaning: "Direct communication is clearer and more honest than indirect messages",
    words: [
      { arabic: "الوجه", transliteration: "al-wajh", translation: "the face" },
      { arabic: "بالوجه", transliteration: "bil-wajh", translation: "with the face" },
      { arabic: "أبيض", transliteration: "abyad", translation: "white/pure" },
    ],
  },
  {
    id: "relationships_4",
    category: "Relationships & Life Lessons",
    arabic: "نام مظلوم ولا تنام ظالم",
    transliteration: "Nam mathloom wala tinam thalim",
    translation: "Sleep oppressed rather than sleep as an oppressor",
    meaning: "It's better to suffer wrong than to do wrong to others",
    words: [
      { arabic: "نام", transliteration: "nam", translation: "sleep" },
      { arabic: "مظلوم", transliteration: "mathloom", translation: "oppressed" },
      { arabic: "ولا", transliteration: "wala", translation: "and not" },
      { arabic: "تنام", transliteration: "tinam", translation: "you sleep" },
      { arabic: "ظالم", transliteration: "thalim", translation: "oppressor" },
    ],
  },
  {
    id: "relationships_5",
    category: "Relationships & Life Lessons",
    arabic: "واللي بالجدر يطلعه الملاس",
    transliteration: "Walli bil-jidir yitla'ah al-milas",
    translation: "What's in the pot will be brought out by the spoon",
    meaning: "The truth will eventually come to light",
    words: [
      { arabic: "واللي", transliteration: "walli", translation: "and what" },
      { arabic: "بالجدر", transliteration: "bil-jidir", translation: "in the pot" },
      { arabic: "يطلعه", transliteration: "yitla'ah", translation: "will bring it out" },
      { arabic: "الملاس", transliteration: "al-milas", translation: "the spoon" },
    ],
  },
  {
    id: "relationships_6",
    category: "Relationships & Life Lessons",
    arabic: "القلوب شواهد",
    transliteration: "Al-quloob shawahed",
    translation: "Hearts are witnesses",
    meaning: "Our inner feelings and intuitions often reveal the truth about situations and people",
    words: [
      { arabic: "القلوب", transliteration: "al-quloob", translation: "hearts" },
      { arabic: "شواهد", transliteration: "shawahed", translation: "witnesses" },
    ],
  },

  // Final Wisdom
  {
    id: "final_1",
    category: "Final Wisdom",
    arabic: "أطعم الفم تستحى العين",
    transliteration: "At'im al-fam tistahi al-'ain",
    translation: "Feed the mouth and the eye will become shy",
    meaning:
      "Generosity and hospitality create respect and prevent criticism. This proverb encapsulates the Kuwaiti value of generosity and its social importance",
    words: [
      { arabic: "أطعم", transliteration: "at'im", translation: "feed" },
      { arabic: "الفم", transliteration: "al-fam", translation: "the mouth" },
      { arabic: "تستحى", transliteration: "tistahi", translation: "will become shy" },
      { arabic: "العين", transliteration: "al-'ain", translation: "the eye" },
    ],
  },
];

export default phrases;
